import { Component } from '@angular/core';

@Component({
  selector: 'app-opportunity-quotes',
  templateUrl: './opportunity-quotes.component.html',
  styleUrls: ['./opportunity-quotes.component.scss']
})
export class OpportunityQuotesComponent {
}
